import React, { useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { AssignmentTurnedIn } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { BackToDashboardButton } from '../../common/components/navigation';
import { ApprovalLoadingState, ApprovalStatusFilter, ApprovalsGrid, InboxFilter } from '../components';
import { useApprovalInbox } from '../hooks/useApprovalInbox';

const ApprovalsInboxPage: React.FC = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<InboxFilter>('pending');
  const { rows, isLoading, isFetching, isError, refetch } = useApprovalInbox(filter);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 1.5, px: 2 }}>
      <Box display="flex" justifyContent="center">
        <Card
          sx={{
            minWidth: 1200,
            maxWidth: 1200,
            width: '100%',
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#ffffff', borderBottom: '2px solid #3b82f6', p: 2.5 }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box>
                <Stack direction="row" alignItems="center" gap={1}>
                  <AssignmentTurnedIn sx={{ color: '#3b82f6' }} />
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#1e293b' }}>
                    My Approvals
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
                  Workflow approval requests addressed to you. Click a row to review and act.
                </Typography>
              </Box>
              <BackToDashboardButton />
            </Box>
          </Box>

          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <ApprovalStatusFilter value={filter} onChange={setFilter} />

            {(isLoading || isFetching) && <ApprovalLoadingState />}

            {isError && (
              <Alert severity="error" action={<Button onClick={() => refetch()}>Retry</Button>}>
                Failed to load approvals.
              </Alert>
            )}

            {!isLoading && !isFetching && !isError && (
              <ApprovalsGrid
                approvals={rows}
                onRowClick={(id) => navigate(`/approvals/${id}`)}
                emptyMessage={`No ${filter} approvals.`}
              />
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ApprovalsInboxPage;
